import { Text } from '@mantine/core'
import { useTranslation } from 'react-i18next'

interface TruncatedTextCellProps {
  text: string
  maxLength?: number
  onShowMore?: () => void
}

export const TruncatedTextCell = ({
  text,
  maxLength = 215,
  onShowMore,
}: TruncatedTextCellProps) => {
  const { t } = useTranslation(['common'])

  if (!text || !text.length) return '–'

  return (
    <>
      <Text
        lineClamp={4}
        classNames={{
          root: 'flex flex-col w-full mb-6 text-sm font-body',
        }}
      >
        {text}
      </Text>
      {text.length > maxLength && onShowMore && (
        <button
          type='button'
          className='bg-transparent border-none text-blue px-0'
          onClick={onShowMore}
        >
          {t('webinar:show_more')}
        </button>
      )}
    </>
  )
}
